import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from '@/pages/HomePage';
import SearchResults from '@/pages/SearchResults';
import PropertyDetail from '@/pages/PropertyDetail';
import BookingCheckout from '@/pages/BookingCheckout';
import PropertyOnboarding from '@/pages/PropertyOnboarding';
import PropertyLogin from '@/pages/PropertyLogin';
import PropertyRegister from '@/pages/PropertyRegister';
import PropertyDashboard from '@/pages/PropertyDashboard';
import PropertyOwnerDashboard from '@/pages/PropertyOwnerDashboard';
import PropertyOwnerDashboardNew from '@/pages/PropertyOwnerDashboardNew';
import UnifiedMarketplace from '@/pages/UnifiedMarketplace';
import TravelerRegistration from '@/pages/TravelerRegistration';
import PropertyRegistrationPage from '@/pages/PropertyRegistrationPage';
import TravelerRegistrationPage from '@/pages/TravelerRegistrationPage';
import TravelerDashboard from '@/pages/TravelerDashboard';
import PaymentSuccess from '@/pages/PaymentSuccess';
import PaymentCancel from '@/pages/PaymentCancel';
import TermsAndConditions from '@/pages/TermsAndConditions';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import { AuthProvider } from '@/contexts/AuthContext';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<UnifiedMarketplace />} />
          <Route path="/onboarding" element={<PropertyOnboarding />} />
          <Route path="/property/register" element={<PropertyRegistrationPage />} />
          <Route path="/owner/login" element={<PropertyLogin />} />
          <Route path="/owner/register" element={<PropertyRegister />} />
          <Route path="/owner/dashboard" element={<PropertyOwnerDashboardNew />} />
          <Route path="/traveler/register" element={<TravelerRegistrationPage />} />
          <Route path="/traveler/dashboard" element={<TravelerDashboard />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  );
}

export default App;